import { render, staticRenderFns } from "./KnownMeasuresList.vue?vue&type=template&id=4d05dffa&"
import script from "./KnownMeasuresList.vue?vue&type=script&lang=js&"
export * from "./KnownMeasuresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports